<script setup lang="ts">
  import IconLabel from '@leaflink/stash/IconLabel.vue';
  import { storeToRefs } from 'pinia';
  import { I18nT } from 'vue-i18n';

  import { SPLIT_NAMES } from '@/constants';
  import { useUserStore } from '@/piniaStores/user/user.store';
  import i18n from '@/plugins/i18n';

  const userStore = useUserStore();

  const { getIsSplitEnabled } = storeToRefs(userStore);

  const isCashbackEnabled = getIsSplitEnabled.value(SPLIT_NAMES.CASHBACK_REWARDS);
</script>

<template>
  <div class="tw-flex lg:tw-block tw-flex-col tw-h-full lg:tw-h-auto">
    <div>
      <div v-if="isCashbackEnabled" class="tw-bg-green-100 tw-p-3 tw-text-center">
        <div class="tw-text-2xl tw-font-medium tw-text-green-700">
          {{ i18n.t('termsAndConditions.directPayTermsConfirmation.buyer.cashBackRate') }}
        </div>
        <div class="tw-text-ice-900 tw-text-xs">
          {{ i18n.t('termsAndConditions.directPayTermsConfirmation.buyer.cashBackRateDescription') }}
        </div>
      </div>
      <ul class="tw-space-y-3" :class="{ 'tw-mt-6': isCashbackEnabled }">
        <li>
          <IconLabel icon="circle-check" color="green-500" class="text-ice-900 tw-text-sm">
            {{
              isCashbackEnabled
                ? i18n.t('termsAndConditions.directPayTermsConfirmation.buyer.bullet1WithCashback')
                : i18n.t('termsAndConditions.directPayTermsConfirmation.buyer.bullet1')
            }}
          </IconLabel>
        </li>
        <li>
          <IconLabel icon="circle-check" color="green-500" class="text-ice-900 tw-text-sm">
            {{ i18n.t('termsAndConditions.directPayTermsConfirmation.buyer.bullet2') }}
          </IconLabel>
        </li>
        <li>
          <IconLabel icon="circle-check" color="green-500" class="text-ice-900 tw-text-sm">
            {{ i18n.t('termsAndConditions.directPayTermsConfirmation.buyer.bullet3') }}
          </IconLabel>
        </li>
      </ul>

      <h3 class="tw-mt-6 tw-mb-3">
        {{ i18n.t('termsAndConditions.self') }}
      </h3>
      <I18nT keypath="termsAndConditions.directPayTermsConfirmation.termsDescription" scope="global" tag="p">
        <template #payments>
          <strong>{{ i18n.t('common.payments') }}</strong>
        </template>
        <template #logistics>
          <strong>{{ i18n.t('common.logistics') }}</strong>
        </template>
      </I18nT>
    </div>
    <div class="tw-overflow-auto tw-flex-1 lg:tw-h-[180px] tw-bg-ice-100 tw-p-3">
      <div
        v-html="i18n.t('termsAndConditions.directPayTermsConfirmation.termsBody')"
        class="tw-text-ice-900 tw-text-xs"
      ></div>
    </div>
    <p class="tw-text-ice-900 tw-text-sm tw-mt-6 tw-mb-0">
      {{ i18n.t('termsAndConditions.directPayTermsConfirmation.legalNotice') }}
    </p>
  </div>
</template>
